<template>
  <div class="journey-item">
    <div class="title fw-bold">Journey</div>
    <div class="" v-if="journey.operator">Operator: <span class="fw-bold">{{ findOperator(journey.operator).name }}</span></div>
    <div class="">Route: <span class="fw-bold">{{ findAirport(journey.departure.from).iata }} | {{ findAirport(journey.departure.to).iata }}</span></div>
    <div class="">Class: <span class="fw-bold"><span>{{ journey.trip == 'round' ? 'Roundtrip' : 'One way' }}</span> - {{ findType(journey.type).name }}</span></div>

    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th v-if="journey.departure.flight_number ">Flight #</th>
          <th>Date</th>
          <th>Departure</th>
          <th>Time</th>
          <th>Arrival</th>
          <th>Time</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Departure</td>
          <td v-if="journey.departure.flight_number">{{ journey.departure.flight_number }}</td>
          <td class="date"><span v-if="journey.departure.departure_date">{{ $filters.formatDateAmerican(journey.departure.departure_date) }}</span></td>
          <td>{{ findAirport(journey.departure.from).island_city  }}</td>
          <td>{{ journey.departure.departure_time }}</td>
          <td>{{ findAirport(journey.departure.to).island_city  }}</td>
          <td>{{ journey.departure.arrival_time }}</td>
        </tr>

        <tr v-if="journey.trip === 'round'">
          <td>Return</td>
          <td v-if="journey.return.flight_number">{{ journey.return.flight_number }}</td>
          <td class="date"><span v-if="journey.return.departure_date">{{ $filters.formatDateAmerican(journey.return.departure_date) }}</span></td>
          <td>{{ findAirport(journey.return.from).island_city }}</td>
          <td>{{ journey.return.departure_time }}</td>
          <td>{{ findAirport(journey.return.to).island_city }}</td>
          <td>{{ journey.return.arrival_time }}</td>
        </tr>
      </tbody>
    </table>

    <div class="actions">
      <button class="btn btn-outline-danger" @click="removeJourney(index)">Delete</button>
      <EditJourneyModal :form="form" :journey="journey" :airports="airports" :types="types" />
    </div>
  </div>
</template>

<script>
import EditJourneyModal from './EditJourneyModal'

export default {
  name: 'JourneyCard',
  components: {
    EditJourneyModal
  },
  props: ['form', 'journey', 'airports', 'operators', 'types', 'index'],
  methods: {
    findAirport(airportId) {
      return this.$parent.airports.filter(function(item){
          if(item.id == airportId) return item;
      })[0]
    },
    findOperator(operatorId) {
      return this.$parent.operators.filter(function(item){
          if(item.id == operatorId) return item;
      })[0]
    },
    findType(typeId) {
      return this.$parent.types.filter(function(item){
          if(item.id == typeId) return item;
      })[0]
    },
    removeJourney(index) {
      this.form.journeys.splice(index, 1);
    }
  }
}
</script>

<style lang="scss">
.journey-item {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid $gray-200;
  border-radius: $border-radius;

  .table {
    font-size: $font-size-sm;
  }

  .date {
    text-transform: uppercase;
  }
}
</style>
